(function(angular, module) {var LogItem, stateChangeLogProvider, stateChangeLogRun,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

LogItem = (function() {
  function LogItem(Principal, time, stateChangeArgs) {
    this.user_id = parseInt(Principal.id);
    this.uuid = Principal.uuid;
    this.timestamp = time;
    this.to_state = stateChangeArgs[0].name;
    this.to_params = stateChangeArgs[1];
    this.from_state = stateChangeArgs[2].name;
    this.from_params = stateChangeArgs[3];
  }

  LogItem.prototype.toString = function() {
    return this.fromState + " -> " + this.toState;
  };

  return LogItem;

})();

stateChangeLogProvider = function() {
  var delay;
  delay = 30 * 1000;
  this.delay = function(value) {
    if (value != null) {
      delay = value;
    }
    return delay;
  };
  this.$get = function($http, $interval, ApiUrl, Principal, moment) {
    'ngInject';
    var StateChangeLog;
    StateChangeLog = (function() {
      function StateChangeLog(delay1) {
        this.delay = delay1;
        this.tick = bind(this.tick, this);
        this.send = bind(this.send, this);
        this.record = bind(this.record, this);
        this.items = [];
        this.intervalCancel = $interval(this.tick, this.delay);
      }

      StateChangeLog.prototype.record = function() {
        var args, event, item;
        event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
        if (Principal.is_anonymous) {
          return;
        }
        item = new LogItem(Principal, moment.utc(), args);
        this.items.push(item);
      };

      StateChangeLog.prototype.send = function() {
        var toSend;
        if (this.items.length === 0) {
          return;
        }
        toSend = this.items;
        this.items = [];
        $http.post(ApiUrl('state_change_log'), toSend);
      };

      StateChangeLog.prototype.tick = function() {
        return this.send();
      };

      return StateChangeLog;

    })();
    return new StateChangeLog(delay);
  };
};

stateChangeLogRun = function($rootScope, StateChangeLog) {
  'ngInject';
  $rootScope.$on('$stateChangeSuccess', StateChangeLog.record);
  return $rootScope.$on('$stateChangeStart', function(event, toState) {
    if (toState.name === 'logout') {
      StateChangeLog.send();
    }
  });
};

module.provider('StateChangeLog', stateChangeLogProvider);

module.run(stateChangeLogRun);
})(angular, angular.module("dyb.util"));